import { EmailRecipient } from '../components/messages/MessageList';

export function formatRecipientNames(emailRecipients: EmailRecipient[]): string {
  const programGroups = emailRecipients.reduce((r, a) => {
    r[a.programName] = r[a.programName] || [];
    r[a.programName].push(a.divisionName);
    return r;
  }, {});
  const list = Object.entries(programGroups).map(([programName, values]) => {
    const divisions: any = values;
    const divisionNames: string = divisions.join(', ');
    return `${programName} (${divisionNames})`;
  });
  return list.join(', ');
}

export function formatNumberToAmountWithCommasAndTwoDecimals(amount: number): string {
  return Number(amount.toFixed(2)).toLocaleString('en', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
